import {
  cilBell,
  cilCalculator,
  cilChartPie,
  cilCheckCircle,
  cilCloudDownload,
  cilCursor,
  cilDrop,
  cilLayers,
  cilMagnifyingGlass,
  cilPencil,
  cilPuzzle,
  cilSettings,
  cilSpeedometer,
  cilStar,
  cilUser,
  cilXCircle,
} from '@coreui/icons'

import { logo } from './logo'
export const iconsSet = Object.assign(
    {},
    { logo },
    {
      cilBell,
      cilCalculator,
      cilChartPie,
      cilCheckCircle,
      cilCloudDownload,
      cilCursor,
      cilDrop,
      cilLayers,
      cilMagnifyingGlass,
      cilPencil,
      cilPuzzle,
      cilSettings,
      cilSpeedometer,
      cilStar,
      cilUser,
      cilXCircle,
    }
)
